export abstract class ValueObject<T> {
  constructor(protected readonly _value: T) {
    this.validate()
  }

  public get value(): T {
    return this._value
  }

  public equals(other?: ValueObject<T>): boolean {
    if (other === null || other === undefined) return false
    if (this === other) return true
    if (Object.getPrototypeOf(this) !== Object.getPrototypeOf(other))
      return false
    return this.isEqual(other)
  }

  public toString(): string {
    return String(this._value)
  }

  protected getEqualityComponents(): unknown[] {
    return [this._value]
  }

  protected isEqual(other: ValueObject<T>): boolean {
    const a = this.getEqualityComponents()
    const b = other.getEqualityComponents()
    return this.stringify(a) === this.stringify(b)
  }

  private stringify(value: unknown): string {
    const json = JSON.stringify(value, (_key: string, val: unknown) =>
      typeof val === 'bigint' ? val.toString() : val
    )
    return typeof json === 'string' ? json : ''
  }

  protected abstract validate(): void
}
